var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var sortOptions = [
    { value: "default", label: "Default" },
    { value: "arrival", label: "Arrival date" },
    { value: "name", label: "Name (A-Z)" },
    { value: "species", label: "Species (A-Z)" },
];
export var sortMethods = sortOptions.map(function (opt) { return opt.value; });
/**
 * Sorts an array of ambassador entries based on the specified sort method.
 * @param ambassadors - Array of [key, ambassador] tuples
 * @param sortMethod - The sorting method to apply
 * @param sortPartialDates - Function to sort partial dates (for arrival sorting)
 * @returns Sorted array of ambassador entries
 */
export var sortAmbassadors = function (ambassadors, sortMethod, sortPartialDates) {
    switch (sortMethod) {
        case "arrival":
            return __spreadArray([], ambassadors, true).sort(function (_a, _b) {
                var a = _a[1];
                var b = _b[1];
                return sortPartialDates(a.arrival, b.arrival);
            });
        case "name":
            return __spreadArray([], ambassadors, true).sort(function (_a, _b) {
                var a = _a[1];
                var b = _b[1];
                return a.name.localeCompare(b.name, undefined, { sensitivity: "base" });
            });
        case "species":
            return __spreadArray([], ambassadors, true).sort(function (_a, _b) {
                var a = _a[1];
                var b = _b[1];
                return a.species.name.localeCompare(b.species.name, undefined, {
                    sensitivity: "base",
                });
            });
        case "default":
        default:
            return ambassadors;
    }
};
export default sortOptions;
